
import { BusinessUnitId__get_unwrap as BusinessUnitId__get_unwrap_1, FormState__setValidationResponse_5219762A, FormState__startLoading, RequestedValue$1, FormKind as FormKind_1, FormState_get_empty } from "../../Shared/Shared.js";
import { Msg, FormValues, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getBusinessUnits } from "../../Requests/BusinessUnit.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { BusinessUnitCreateDto_$reflection, BusinessUnitCreateDto, BusinessUnitUpdateDto_$reflection, BusinessUnitUpdateDto, BusinessUnitDetailDto_$reflection } from "../../Shared/BusinessUnit.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { BusinessUnitId__get_unwrap } from "../../Shared/Shared.js";
import { map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export const initState = new State(FormState_get_empty(), new FormKind_1(0, []), new RequestedValue$1(0, []), undefined, new RequestedValue$1(0, []));

export function initNewView(userData) {
    return [new State(initState.FormState, new FormKind_1(0, []), new RequestedValue$1(1, [new FormValues("", "", undefined, undefined)]), initState.BusinessUnitId, initState.BusinessUnits), Cmd_batch(singleton(getBusinessUnits((Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(7, [Item_1])))))];
}

export function initEditView(userData, businessUnitId) {
    return [new State(initState.FormState, new FormKind_1(1, []), initState.Form, businessUnitId, initState.BusinessUnits), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), BusinessUnitDetailDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/business-units/", ...BusinessUnitId__get_unwrap(businessUnitId)), (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(7, [Item_1]))), getBusinessUnits((Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(7, [Item_3])))]))];
}

export function update(msg, state) {
    let body, xs, xs_2;
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = state.Form;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form_1 = matchValue_1.fields[0];
                return [new State(state.FormState, state.FormKind, new RequestedValue$1(1, [new FormValues(form_1.Name, msg.fields[0], form_1.SelectedParentBusinessUnitId, form_1.ImageUrl)]), state.BusinessUnitId, state.BusinessUnits), Cmd_none()];
            }
        }
        case 2: {
            const matchValue_2 = state.Form;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form_2 = matchValue_2.fields[0];
                return [new State(state.FormState, state.FormKind, new RequestedValue$1(1, [new FormValues(form_2.Name, form_2.Description, map((value_3) => value_3.value.Id, msg.fields[0]), form_2.ImageUrl)]), state.BusinessUnitId, state.BusinessUnits), Cmd_none()];
            }
        }
        case 5: {
            const response = msg.fields[0];
            return [new State(state.FormState, state.FormKind, new RequestedValue$1(1, [new FormValues(response.Name, response.Description, response.ParentId, response.ImageUrl)]), state.BusinessUnitId, state.BusinessUnits), Cmd_none()];
        }
        case 6:
            return [new State(state.FormState, state.FormKind, state.Form, state.BusinessUnitId, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 3: {
            const matchValue_3 = state.Form;
            const matchValue_4 = state.FormKind;
            const matchValue_5 = state.BusinessUnitId;
            let matchResult, businessUnitId, form_3, form_4;
            if (matchValue_3.tag === 0) {
                switch (matchValue_4.tag) {
                    case 1: {
                        if (matchValue_5 != null) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 2;
                        }
                        break;
                    }
                    case 2: {
                        if (matchValue_5 != null) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 2;
                        }
                        break;
                    }
                    default:
                        if (matchValue_5 != null) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 2;
                        }
                }
            }
            else {
                switch (matchValue_4.tag) {
                    case 0: {
                        if (matchValue_5 != null) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 1;
                            form_4 = matchValue_3.fields[0];
                        }
                        break;
                    }
                    case 2: {
                        if (matchValue_5 != null) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 2;
                        }
                        break;
                    }
                    default:
                        if (matchValue_5 == null) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 0;
                            businessUnitId = matchValue_5;
                            form_3 = matchValue_3.fields[0];
                        }
                }
            }
            switch (matchResult) {
                case 0: {
                    const dto = new BusinessUnitUpdateDto(form_3.Name, form_3.Description, form_3.SelectedParentBusinessUnitId, form_3.ImageUrl);
                    return [new State(FormState__startLoading(state.FormState), state.FormKind, state.Form, state.BusinessUnitId, state.BusinessUnits), (body = toString(0, Auto_generateBoxedEncoder_437914C6(BusinessUnitUpdateDto_$reflection(), undefined, undefined, undefined)(dto)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_2;
                        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_2) => {
                            const pr = response_2.arrayBuffer();
                            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                        }, refreshOn)))(true);
                    })), [concat("/api/business-units/", ...BusinessUnitId__get_unwrap(businessUnitId)), body], (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(7, [Item_1]))))];
                }
                case 1: {
                    const dto_2 = new BusinessUnitCreateDto(form_4.Name, form_4.Description, form_4.SelectedParentBusinessUnitId);
                    return [new State(FormState__startLoading(state.FormState), state.FormKind, state.Form, state.BusinessUnitId, state.BusinessUnits), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_4) => {
                            const pr_1 = response_4.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                        }, refreshOn_1)))(true);
                    })), ["/api/business-units", toString(0, Auto_generateBoxedEncoder_437914C6(BusinessUnitCreateDto_$reflection(), undefined, undefined, undefined)(dto_2))], (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(7, [Item_3])))];
                }
                default:
                    return [state, Cmd_errorToast("general.a_error_occured")];
            }
        }
        case 4: {
            const response_6 = msg.fields[0];
            if (response_6.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_6.fields[0]), state.FormKind, state.Form, state.BusinessUnitId, state.BusinessUnits), Cmd_errorToast("validation.toast")];
            }
            else {
                const matchValue_7 = state.FormKind;
                const matchValue_8 = state.BusinessUnitId;
                let matchResult_1;
                switch (matchValue_7.tag) {
                    case 0: {
                        if (matchValue_8 != null) {
                            matchResult_1 = 2;
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        break;
                    }
                    case 2: {
                        if (matchValue_8 != null) {
                            matchResult_1 = 2;
                        }
                        else {
                            matchResult_1 = 2;
                        }
                        break;
                    }
                    default:
                        if (matchValue_8 == null) {
                            matchResult_1 = 2;
                        }
                        else {
                            matchResult_1 = 0;
                        }
                }
                switch (matchResult_1) {
                    case 0: {
                        const businessUnitId_2 = matchValue_8;
                        return [new State(FormState_get_empty(), state.FormKind, state.Form, state.BusinessUnitId, state.BusinessUnits), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), (xs = ["business-units", BusinessUnitId__get_unwrap_1(businessUnitId_2)], Cmd_ofEffect((_arg) => {
                            RouterModule_nav(ofArray(xs), 1, 1);
                        }))]))];
                    }
                    case 1:
                        return [new State(FormState_get_empty(), state.FormKind, state.Form, state.BusinessUnitId, state.BusinessUnits), Cmd_batch(ofArray([(xs_2 = ["business-units", response_6.fields[0]], Cmd_ofEffect((_arg_1) => {
                            RouterModule_nav(ofArray(xs_2), 1, 1);
                        })), Cmd_successToast("general.saved_successfully")]))];
                    default:
                        return [state, Cmd_errorToast("general.a_error_occured")];
                }
            }
        }
        case 7:
            return [new State(FormState_get_empty(), state.FormKind, state.Form, state.BusinessUnitId, state.BusinessUnits), Cmd_errorToast("general.a_error_occured")];
        default: {
            const matchValue = state.Form;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const form = matchValue.fields[0];
                return [new State(state.FormState, state.FormKind, new RequestedValue$1(1, [new FormValues(msg.fields[0], form.Description, form.SelectedParentBusinessUnitId, form.ImageUrl)]), state.BusinessUnitId, state.BusinessUnits), Cmd_none()];
            }
        }
    }
}

